/* eslint-disable no-empty-pattern */
import React, { useState, useContext, useEffect } from "react"
import CAFlag from "../../assets/img/flags/canada.png"
import { StateContext } from "../../contextApi"
import { validateEmail, closeModalOnClick } from "../../util/util"
import Input from "../utility/library/Input"
import { Img } from "react-image"
import styled from "styled-components"

const WaitlistFormModalStyle = styled.div`
  font-family: 'Muli', sans-serif;
  .modal-content {
    max-width: 533px !important;
    position: relative;
  }
  .kuda-modal--content {
    max-width: 420px !important;
  }
  button {
    font-family: 'Muli', sans-serif;

  }
  .disable-button {
    opacity: 0.5;
    transition: none;
    pointer-events: none;
  }

  .waitlist-loader {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    position: relative;
    animation: rotate 1s linear infinite;
  }
  .waitlist-loader::before {
    content: "";
    box-sizing: border-box;
    position: absolute;
    inset: 0px;
    border-radius: 50%;
    border: 3px solid #fff;
    animation: prixClipFix 2s linear infinite;
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes prixClipFix {
    0% {
      clip-path: polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0);
    }
    25% {
      clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 0, 100% 0, 100% 0);
    }
    50% {
      clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 100% 100%, 100% 100%);
    }
    75% {
      clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 100%);
    }
    100% {
      clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 0);
    }
  }

  @media only screen and (max-width: 1024px) {
    .modal-content {
      max-width: 445px !important;
    }
  }
  @media only screen and (max-width: 768px) {
    .modal-content {
      margin: auto;
      max-width: 380px !important;
    }
  }
`

const WaitlistFormModal = () => {
  const [state, setState] = useState({
    form: {
      name: "",
      email: "",
    },
    isSubmitting: false,
    isFormValid: true,
  })
  const [errors, setErrors] = useState({
    name: "",
    email: "",
  })
  const [{ }, dispatch] = useContext(StateContext)

  useEffect(() => {
    document.body.classList.add("backdrop-init")
    closeModalOnClick(closeModal)
    return () => {
      document.body.classList.remove("backdrop-init")
    }
  }, [])
  const handleChange = (key, value) => {
    const newStateForm = { ...state.form }

    setState({
      ...state,
      form: {
        ...newStateForm,
        [key]: value,
      },
    })
    if (key === "name") {
      setErrors({
        ...errors,
        name: value.length > 0 ? "" : "Name is a required field",
      })
    } else {
      setErrors({
        ...errors,
        email: validateEmail(value),
      })
    }
  }

  async function handleDataUpload(formData) {
    const DeploymentID = `AKfycbzbuFvE_khdR0T8smHOL5BZZP2Bu6RuMX9hFZYj2pATj_ehrhFVi12Ft-JmtKZpPTHY`
    const WebAppURL = `https://script.google.com/macros/s/${DeploymentID}/exec?Name=${state.form.name}&Email=${state.form.email}`


    try {
      const response = await fetch(WebAppURL, {
        method: "POST",
        body: JSON.stringify(formData),
      })

      return response
    } catch (error) {
      closeModal()
      // DISPATCH ERROR MODAL TRUE
      dispatch({
        newPayload: true,
        type: "CHANGE_ERROR",
      })
      return error
    }
  }

  async function onFormSubmit(e) {
    e.preventDefault()
    setState({
      ...state,
      isSubmitting: true,
    })

    const params = {
      Name: state.form.name,
      Email: state.form.email,
    }

    const responseData = await handleDataUpload(params)
    if (responseData.ok) {
      // clear form.
      setState({
        ...state,
        form: {
          name: "",
          email: "",
        },
        isSubmitting: false,
      })
      closeModal()
      // DISPATCH SUCCESS MODAL TRUE
      dispatch({
        newPayload: {
          status: true,
          message: `We’ll send you updates when we have them.`,
          header: "Thanks",
          button: "Okay",
        },
        type: "CHANGE_SUCCESS_MODAL",
      })
    }
  }

  const closeModal = async () => {
    dispatch({
      key: "waitlistForm",
      value: false,
      type: "CHANGE_VIEW_MODALS",
    })
  }

  const validateButton = () => {
    if (
      state.form.email.length === 0 ||
      state.form.name.length === 0 ||
      validateEmail(state.form.email).length > 0
    ) {
      return false
    } else if (errors.email.length > 0 || errors.name.length > 0) {
      return false
    }
    return true
  }

  return (
    <WaitlistFormModalStyle>
      <div className="modal modal-sendMoney small-modal modal-backdrop fadeIn animated">
        <div className="modal-content fadeInUp animated ">
          <div
            className="closeModal"
            style={{ top: "5px", left: "4px" }}
            onClick={closeModal}
            dangerouslySetInnerHTML={{
              __html:
                '<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.22178 8.22183C7.63599 8.80761 7.63599 9.75736 8.22178 10.3431L13.8786 16L8.22178 21.6569C7.63599 22.2426 7.63599 23.1924 8.22178 23.7782C8.80756 24.364 9.75731 24.364 10.3431 23.7782L16 18.1213L21.6568 23.7782C22.2426 24.364 23.1923 24.364 23.7781 23.7782C24.3639 23.1924 24.3639 22.2426 23.7781 21.6569L18.1213 16L23.7781 10.3431C24.3639 9.75736 24.3639 8.80761 23.7781 8.22183C23.1923 7.63604 22.2426 7.63604 21.6568 8.22183L16 13.8787L10.3431 8.22183C9.75731 7.63604 8.80756 7.63604 8.22178 8.22183Z" fill="#4D4D4D" style="mix-blend-mode:color-burn"/><path fill-rule="evenodd" clip-rule="evenodd" d="M8.22178 8.22183C7.63599 8.80761 7.63599 9.75736 8.22178 10.3431L13.8786 16L8.22178 21.6569C7.63599 22.2426 7.63599 23.1924 8.22178 23.7782C8.80756 24.364 9.75731 24.364 10.3431 23.7782L16 18.1213L21.6568 23.7782C22.2426 24.364 23.1923 24.364 23.7781 23.7782C24.3639 23.1924 24.3639 22.2426 23.7781 21.6569L18.1213 16L23.7781 10.3431C24.3639 9.75736 24.3639 8.80761 23.7781 8.22183C23.1923 7.63604 22.2426 7.63604 21.6568 8.22183L16 13.8787L10.3431 8.22183C9.75731 7.63604 8.80756 7.63604 8.22178 8.22183Z" fill="black" fill-opacity="0.4"/></svg>',
            }}
          ></div>
          <div className="kuda-modal--content">
            <h4 className="d-inline-flex mx-auto  color-black text-xbold margin-bottom--spacer text-center align-items-baseline">
              <> Be the first to know when we launch in Canada</>
              <Img
                src={CAFlag}
                className="ca-flag ml-2"
                width={20}
                height={21}
              />
            </h4>
            <div className="message-response withdrawal-response">
              <p className="color-black">
                {" "}
                We'll send you exclusive updates by email or text, no spam.
              </p>
            </div>
            <div className="flex flex-column top--spacing">
              <div className="mt-4">
                <Input
                  label="Your Name"
                  placeholder="First Name"
                  width="100%"
                  name="name"
                  type="text"
                  value={state.form.name}
                  onChange={e => handleChange("name", e.target.value)}
                  error={errors.name.length > 0}
                  message={errors.name}
                />
              </div>
              <div className="mt-4">
                <Input
                  label="Email Address"
                  placeholder="you@example.com"
                  width="100%"
                  name="email"
                  type="text"
                  value={state.form.email}
                  onChange={e => handleChange("email", e.target.value)}
                  error={errors.email.length > 0}
                  message={errors.email}
                />
              </div>
            </div>

            <div className="flex flex-row mt-5 justify-between">
              <button
                className={`kuda-cta-outline kuda-cta-lg kuda_web`}
                onClick={closeModal}
              >
                Cancel
              </button>

              <button
                className={`kuda-cta kuda-cta-lg ${validateButton() ? "" : "disable-button"
                  }`}
                onClick={onFormSubmit}
              >
                {state.isSubmitting ? (
                  // add spinner
                  <div className="waitlist-loader"></div>
                ) : (
                  "Let Me Know"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </WaitlistFormModalStyle>
  )
}

export default WaitlistFormModal
